// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2tI36","savePackageButton":"ClientWallet_savePackageButton__1GksK"};